/* ELMANAR free-shipping progress bar — cart drawer + cart page. Self-contained, bilingual, no deps. */
/* PATCHED 2026-07-12: the fetch() monkey-patch previously attached .then() to the caller's promise
   without a .catch(). Any failed cart request (offline, 4xx/5xx, aborted) produced an
   *unhandled promise rejection*, which Clarity logs as an opaque "Script error.".
   Fixed by observing the promise on a detached, caught branch so we never alter or
   swallow the caller's own promise chain. */
(function () {
  var GOAL = 80000; /* 800.00 EGP in minor units */
  function isAr(){ return (document.documentElement.getAttribute('dir') === 'rtl') || ((document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0); }
  function fmt(c){ var ar=isAr(); var n=Math.round(c/100); try{ return n.toLocaleString(ar?'ar-EG':'en-US') + (ar?' ج.م':' EGP'); }catch(e){ return n + (ar?' ج.م':' EGP'); } }
  function ensureStyle(){
    if (document.getElementById('mnr-fs-style')) return;
    var s=document.createElement('style'); s.id='mnr-fs-style';
    s.textContent='.mnr-fs{padding:12px 14px;margin:0 0 8px;}.mnr-fs__msg{margin:0 0 7px;font-size:13px;font-weight:600;text-align:center;color:rgb(var(--color-foreground,18,18,18));}.mnr-fs__track{height:8px;border-radius:8px;background:rgba(0,0,0,.1);overflow:hidden;}.mnr-fs__fill{display:block;height:100%;border-radius:8px;background:#1f8a4c;transition:width .4s ease;}';
    document.head.appendChild(s);
  }
  function html(total){
    var ar=isAr(); var pct=Math.max(0,Math.min(100,Math.round(total/GOAL*100))); var msg;
    if(total>=GOAL){ msg=ar?'🎉 مبروك! طلبك مؤهل للشحن المجاني':'🎉 Your order qualifies for FREE shipping!'; }
    else { var left=fmt(GOAL-total); msg=ar?('باقي '+left+' وتحصل على شحن مجاني 🚚'):("You're "+left+' away from FREE shipping 🚚'); }
    return '<p class="mnr-fs__msg">'+msg+'</p><div class="mnr-fs__track"><span class="mnr-fs__fill" style="width:'+pct+'%"></span></div>';
  }
  function place(total){
    ensureStyle();
    var hosts=[];
    var df=document.querySelector('#CartDrawer .drawer__footer'); if(df) hosts.push(df);
    var pf=document.querySelector('#main-cart-footer .cart__footer'); if(pf) hosts.push(pf);
    hosts.forEach(function(h){
      var bar=h.querySelector(':scope > .mnr-fs');
      if(!bar){ bar=document.createElement('div'); bar.className='mnr-fs'; h.insertBefore(bar,h.firstChild); }
      bar.innerHTML=html(total);
    });
  }
  function render(){
    try {
      fetch('/cart.js',{headers:{Accept:'application/json'}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){ if (c && typeof c.total_price === 'number') place(c.total_price); })
        .catch(function(){ /* cart unreachable — leave the bar as-is, never throw */ });
    } catch (e) { /* no-op */ }
  }
  var of = window.fetch;
  if (typeof of === 'function' && !window.__mnrFetchPatched) {
    window.__mnrFetchPatched = true;
    window.fetch = function () {
      var p = of.apply(this, arguments);
      try {
        var u = arguments[0];
        u = (u && u.url) || u || '';
        if (typeof u === 'string' && (u.indexOf('/cart/add') > -1 || u.indexOf('/cart/change') > -1 || u.indexOf('/cart/update') > -1 || u.indexOf('/cart/clear') > -1)) {
          /* Observe on a DETACHED branch with its own catch. The caller still receives `p`
             untouched, and a rejected cart request can no longer surface as an
             unhandled rejection / "Script error." */
          Promise.resolve(p).then(
            function () { setTimeout(render, 90); setTimeout(render, 500); },
            function () { /* request failed — swallow here, caller handles its own error */ }
          );
        }
      } catch (e) { /* never let instrumentation break a real fetch */ }
      return p;
    };
  }
  if (document.readyState !== 'loading') render(); else document.addEventListener('DOMContentLoaded', render);
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('#cart-icon-bubble,a[href$="/cart"]');
    if (t) setTimeout(render, 250);
  });
})();
